import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.scss';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, RouterProvider } from "react-router-dom";
import router from "./router";
import "./App.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <BrowserRouter> */}
      <RouterProvider router={router} />
    {/* </BrowserRouter> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
